var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSimulation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 121 92",
    className: "jfWizard-list-item-icon-svg",
    width: 187,
    height: 204,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFF",
    fillRule: "nonzero",
    x: 7.934,
    width: 105.131,
    height: 62.153,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.934 49.59h105.132v9.224a4 4 0 01-4 4H11.934a4 4 0 01-4-4V49.59z",
    fill: "#2A5ACA",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.208 11.24)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#DAE2ED",
    fillRule: "nonzero",
    x: 10.579,
    y: 11.24,
    width: 80.667,
    height: 5.951,
    rx: 2.975
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#DAE2ED",
    fillRule: "nonzero",
    width: 50.913,
    height: 5.951,
    rx: 2.975
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.555 21.82H88.27a2.975 2.975 0 010 5.95H13.555a2.975 2.975 0 010-5.95z",
    fill: "#DAE2ED",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 10.58)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#2F90FF",
    fillRule: "nonzero",
    width: 6.612,
    height: 6.612,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.812 4.96a.337.337 0 01-.245-.107L1.34 3.564a.378.378 0 010-.515.334.334 0 01.49 0l.98 1.031 2.206-2.32a.334.334 0 01.49 0 .378.378 0 010 .515l-2.45 2.578a.337.337 0 01-.245.107",
    fill: "#FFF"
  })), /*#__PURE__*/React.createElement("rect", {
    fill: "#DAE2ED",
    fillRule: "nonzero",
    y: 21.158,
    width: 6.612,
    height: 6.612,
    rx: 2
  })), /*#__PURE__*/React.createElement("rect", {
    fill: "#FFF",
    fillRule: "nonzero",
    width: 121,
    height: 62.153,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 49.59h121v9.224a4 4 0 01-4 4H4a4 4 0 01-4-4V49.59z",
    fill: "#51DCA9",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.257 11.24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.877 11.24H98.85a2.975 2.975 0 010 5.951H14.877a2.975 2.975 0 110-5.95zM2.975 0h50.913a2.975 2.975 0 110 5.95H2.975a2.975 2.975 0 110-5.95zm11.902 21.82H98.85a2.975 2.975 0 010 5.95H14.877a2.975 2.975 0 110-5.95z",
    fill: "#DAE2ED",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 10.58)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#2F90FF",
    fillRule: "nonzero",
    width: 6.612,
    height: 6.612,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.812 4.96a.337.337 0 01-.245-.107L1.34 3.564a.378.378 0 010-.515.334.334 0 01.49 0l.98 1.031 2.206-2.32a.334.334 0 01.49 0 .378.378 0 010 .515l-2.45 2.578a.337.337 0 01-.245.107",
    fill: "#FFF"
  })), /*#__PURE__*/React.createElement("rect", {
    fill: "#DAE2ED",
    fillRule: "nonzero",
    y: 21.158,
    width: 6.612,
    height: 6.612,
    rx: 2
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#319BF3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8.596 86.646h104.47"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#319BF3",
    strokeWidth: 1.5,
    fill: "#51DCA9",
    fillRule: "nonzero",
    cx: 60.831,
    cy: 86.646,
    r: 3.967
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#319BF3",
    fillRule: "nonzero",
    cx: 9.918,
    cy: 86.646,
    r: 3.967
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#319BF3",
    fillRule: "nonzero",
    cx: 111.743,
    cy: 86.646,
    r: 3.967
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimulation);
export default __webpack_public_path__ + "static/media/Simulation.b8618585.svg";
export { ForwardRef as ReactComponent };